module.exports = __webpack_public_path__ + "img/top-logo-2@3x.834fbc4b.png";